import { TabbedGroup } from "../../../components/TabbedGroup";
import { AdminPermissions as AP } from "../../../lib/data";
import Team from "../Team";
import Levels from "../Level";
import Audit from "../Audit";
import Feedback from "../Feedback";
import Settings from "../Settings";

export default function System() {
  return (
    <TabbedGroup
      tabs={[
        { value: "team", label: "Team", permission: AP.MANAGE_ADMINS, element: <Team /> },
        { value: "levels", label: "Levels", permission: AP.MANAGE_CONFIG, element: <Levels /> },
        { value: "audit", label: "Audit Logs", permission: AP.VIEW_AUDIT_LOGS, element: <Audit /> },
        { value: "feedback", label: "App Feedback", permission: AP.MANAGE_USERS, element: <Feedback /> },
        { value: "settings", label: "Settings", permission: AP.MANAGE_CONFIG, element: <Settings /> },
      ]}
    />
  );
}
